// @flow
export const parseHitUnveilClass = (index: number) =>
    `Hit__unveil--img${index}`;
